import React from "react"
import styled, { css } from "styled-components"

const Switch = ({ active }, props) => {
  return (
    <Wrapper {...props}>
      <Rocker>
        <Input type="checkbox" readOnly checked={active} />
        <SwitchLeft>Off</SwitchLeft>
        <SwitchRight>On</SwitchRight>
      </Rocker>
    </Wrapper>
  )
}

export default Switch

const Wrapper = styled.div`
  margin-left: auto;
`

const Rocker = styled.label`
  display: inline-block;
  position: relative;
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  color: #888;
  overflow: hidden;
  border-bottom: 0.5em solid #eee;
  width: 7em;
  height: 4em;
  font-size: 0.7em; /* size of switch */
  pointer-events: none; /* let the parent component handle the actions */

  &::before {
    content: "";
    position: absolute;
    top: 0.5em;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #999;
    border: 0.5em solid #eee;
    border-bottom: 0;
  }

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
`

const sharedSwitchStyle = css`
  cursor: pointer;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5em;
  width: 3em;
  transition: 0.2s;

  &::before {
    content: "";
    position: absolute;
    width: 0.4em;
    height: 2.45em;
    bottom: -0.45em;
    background-color: #ccc;
    transform: skewY(-65deg);
  }
`

const SwitchLeft = styled.span`
  ${sharedSwitchStyle}

  height: 2.4em;
  width: 2.75em;
  left: 0.85em;
  bottom: 0.4em;
  background-color: #ddd;
  transform: rotate(15deg) skewX(15deg);

  &::before {
    left: -0.4em;
  }
`

const SwitchRight = styled.span`
  ${sharedSwitchStyle}

  right: 0.5em;
  bottom: 0;
  background-color: #469c05;
  color: #fff;

  &::before {
    right: -0.375em;
    background-color: transparent;
    transform: skewY(65deg);
  }
`

const Input = styled.input`
  &:checked + ${SwitchLeft} {
    background-color: #469c05;
    color: #fff;
    bottom: 0px;
    left: 0.5em;
    height: 2.5em;
    width: 3em;
    transform: rotate(0deg) skewX(0deg);
  }

  &:checked + ${SwitchLeft}::before {
    background-color: transparent;
    width: 3.0833em;
  }

  &:checked + ${SwitchLeft} + ${SwitchRight} {
    background-color: #ddd;
    color: #888;
    bottom: 0.4em;
    right: 0.8em;
    height: 2.4em;
    width: 2.75em;
    transform: rotate(-15deg) skewX(-15deg);
  }

  &:checked + ${SwitchLeft} + ${SwitchRight}::before {
    background-color: #ccc;
  }

  &:focus + ${SwitchLeft} {
    color: #333;
  }

  &:checked:focus + ${SwitchLeft} {
    color: #fff;
  }

  &:focus + ${SwitchLeft} + ${SwitchRight} {
    color: #fff;
  }

  &:checked:focus + ${SwitchLeft} + ${SwitchRight} {
    color: #333;
  }
`
